import React, { useMemo, useState } from "react";
import { getCookie, getUrlVersion, setMenu } from "../../pages/commons/functions";
import { useGlobalState } from "../../pages/context/GlobalStateContext";



const findMenuByHref = (items: any[], href: string): any | undefined => {
    for (const item of items) {
        if (item.href === href) return item;
        if (item.items && item.items.length > 0) {
            const found = findMenuByHref(item.items, href);
            if (found) return found;
        }
    }
    return undefined;
};

const Favorites: React.FC = () => {

    const { menu } = useGlobalState();
    const currentHash = "#" + window.location.hash.replace(/^#/, "");
    const currentMenu = useMemo(() => {
        if (!menu) return undefined;
        return findMenuByHref(Array.isArray(menu) ? menu : [menu], currentHash);
    }, [menu, currentHash]);



    const [loading, setLoading] = useState(false);
    const handleFavorite = async (add: boolean) => {
        if (!currentMenu) {
            console.warn("No matching menu found for current hash:", currentHash);
            return;
        }
        try {
            setLoading(true)
            const action = '/private/user/favorites/' + (add ? "add" : "remove")

            const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': action,
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idMenu: currentMenu.idMenu
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                if (data.menu) {
                    setMenu(data.menu)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false)
        }
    };
    return (

        <>
            {
                /*
                currentMenu && (
    
                    <SpaceBetween direction="horizontal" size="xs">
                        {loading ? (
                            <Spinner />
                        ) : (
                            <>
                                {currentMenu.isFavorite === 0 && (
                                    <Link onClick={() => handleFavorite(true)}>
                                        <Icon path={mdiHeartOutline} size={1} color="grey" />
                                    </Link>
                                )}
    
                                {currentMenu.isFavorite === 1 && (
                                    <Link onClick={() => handleFavorite(false)}>
                                        <Icon path={mdiHeart} size={1} color="red" />
                                    </Link>
                                )}
                            </>
                        )}
                    </SpaceBetween>
                )
                */
            }
        </>

    );
};

export default Favorites;
